import {createSlice, isAnyOf, PayloadAction} from '@reduxjs/toolkit';
import {DefaultRootState} from 'react-redux';

import {extendedAPI} from 'app/policies/api';
import {revertLocationParamsConvertion} from 'app/store/sweet-api/utils';

import {PoliciesLocationParamsType} from './types';

import {ContentType} from 'sweet-types';

interface ToggleDashboard {
  contentType: ContentType;
  isOpen: boolean;
}

interface DashboardState {
  filters: PoliciesLocationParamsType;
  relations: Record<ContentType, boolean> | Record<string, never>;
}

const initialState: DashboardState = {
  filters: {} as PoliciesLocationParamsType,
  relations: {},
};

const matchFilterChanged = isAnyOf(
  extendedAPI.endpoints.getPolicies.matchPending,
  extendedAPI.endpoints.getPolicies.matchRejected
);

const policiesSlice = createSlice({
  name: 'policies',
  initialState,
  reducers: {
    toggleDashboardRelation(state, action: PayloadAction<ToggleDashboard>) {
      state.relations[action.payload.contentType] = action.payload.isOpen;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(matchFilterChanged, (state, action) => {
      state.filters = revertLocationParamsConvertion(
        action.meta.arg.originalArgs
      );
    });
  },
});

export const {toggleDashboardRelation} = policiesSlice.actions;

export const selectPolicyFilters = (state: DefaultRootState) =>
  state.policies.filters;

export const policiesReducer = policiesSlice.reducer;
